import { __awaiter } from 'tslib';
import { ethers } from 'ethers';
import { getCoinbaseProvider, fetchPublicAddress, signMessage, killCoinbaseSession } from '../clients/coinbase/coinbase.js';
import { normalizeWalletName } from '../../utils/normalizeWalletName/normalizeWalletName.js';
import { EthProviderHelper } from './ethProviderHelper.js';
import { EthProvider } from './ethProvider.js';

class Coinbase extends EthProvider {
    constructor({ appName, appLogoUrl, evmNetworks, }) {
        super({ evmNetworks });
        this.name = 'Coinbase';
        this.supportedChains = ['EVM', 'ETH'];
        this.connectedChain = 'EVM';
        this.canConnectViaQrCode = true;
        this.canConnectViaCustodialService = false;
        this.isWalletConnect = false;
        this.ethProviderHelper = new EthProviderHelper();
        this.coinbaseProviderOpts = {
            appLogoUrl: appLogoUrl,
            appName: appName,
            evmNetworks: evmNetworks,
        };
    }
    get key() {
        return normalizeWalletName(this.name);
    }
    setupEventListeners(listeners) {
        return this.ethProviderHelper._setupEventListeners(listeners, this.getWeb3Provider());
    }
    teardownEventListeners() {
        return this.ethProviderHelper._teardownEventListeners(this.name);
    }
    getWeb3Provider() {
        if (this.isInstalledOnBrowser()) {
            return this.ethProviderHelper.findProvider(this.name);
        }
        return new ethers.providers.Web3Provider(getCoinbaseProvider({
            opts: this.coinbaseProviderOpts,
        }), 'any');
    }
    isInstalledOnBrowser() {
        return this.ethProviderHelper.isInstalledHelper(this.name);
    }
    connect() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.fetchPublicAddress();
        });
    }
    fetchPublicAddress(opts) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.isInstalledOnBrowser()) {
                return this.ethProviderHelper.fetchPublicAddressWithName(this.name);
            }
            return fetchPublicAddress(this.coinbaseProviderOpts, opts);
        });
    }
    signMessage(messageToSign) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.isInstalledOnBrowser()) {
                return this.ethProviderHelper.signMessageWithName(messageToSign, this.name);
            }
            return signMessage(this.coinbaseProviderOpts, messageToSign);
        });
    }
    proveOwnership(messageToSign) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.signMessage(messageToSign);
        });
    }
    endSession() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.isInstalledOnBrowser())
                return;
            killCoinbaseSession();
        });
    }
}

export { Coinbase as default };
